import { Component, OnInit } from '@angular/core';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { CurrencyComponent } from '../../../../shared/components/price/currency.component';
import { SessionRepository } from 'src/app/shared/repositories/session.repository';
import { BasketRepository } from '../../../../shared/repositories/basket.repository';
import { Observable } from 'rxjs';
import { BasketMiniComponent } from '../basket-mini/basket-mini.component';
import { NavigationEnd, Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-basket-preview',
  standalone: true,
  templateUrl: './basket-preview.component.html',
  styleUrls: ['./basket-preview.component.scss'],
  imports: [
    NgIf,
    NgClass,
    AsyncPipe,
    RouterLink,
    CurrencyComponent,
    BasketMiniComponent,
  ],
})
export class BasketPreviewComponent implements OnInit {
  constructor(
    private sessionRepository: SessionRepository,
    private basketRepository: BasketRepository,
    private router: Router,
  ) { }

  totalPrice$: Observable<number> = this.sessionRepository.totalPrice$;
  actualDeliveryPrice$: Observable<number> = this.sessionRepository.actualDeliveryPrice$;
  totalCount$: Observable<number> = this.basketRepository.itemsAmount$;
  isShowBasket: boolean = false;

  isOrderingPage: boolean = false;

  ngOnInit(): void {
    this.sessionRepository.checkBasketAvailable();
    this.subscribeToRouter();

    if (this.router.url.includes('/ordering')) {
      this.isOrderingPage = true;
    }
  }

  private subscribeToRouter(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isOrderingPage = event.url.includes('/ordering');
      }
    });
  }

  onOpenBasket(): void {
    if (!this.basketRepository.totalCount) { return }
    this.isShowBasket = true;
  }

  onClose(): void {
    this.isShowBasket = false;
  }

  onClear(): void {
    this.sessionRepository.removeBasket(true);
    this.isShowBasket = false;
  }
}
